import { ThemeUICSSObject } from 'theme-ui';
import { spacing } from '../../util';
import getColorsByPath from '../colors/util/getColorsByPath';
/* IMPORT HERE */

const iconInput: ThemeUICSSObject = {
  display: 'flex',
  gap: spacing(1),
  justifyContent: 'stretch',
  alignItems: 'center',
  '&.readOnly': {
    input: {
      ...getColorsByPath('form.fields'),
    },
  },

  input: {
    height: '50px',
    width: '100%',
  },

  button: {
    display: 'flex',
    width: '45px',
    flexShrink: 0,
    height: '50px',
  },
};

export default iconInput;
